import { render, staticRenderFns } from "./DiskOptionsUpdate.vue?vue&type=template&id=3dfd49af&"
import script from "./DiskOptionsUpdate.vue?vue&type=script&lang=js&"
export * from "./DiskOptionsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports